// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld/base/core';
import layerControlHtml from 'text!html/layerControl.html';
import 'myWorld/base/view';
import 'jquery-ui';
import 'jquery-ui-touch';
import './layerControlItem';
import './checkbox';
import './widgetRendererMixin';

const layerRowHtml = $(layerControlHtml)
    .filter('#layer-row-template')
    .html();

myw.LayerControlRow = myw.View.extend({
    innerTemplate: _.template(layerRowHtml),

    events: {
        click: 'toggleCheckbox',
        'click .layer-checkbox': 'updateSelection',
        'click .layer-list-delete': 'remove'
    },

    includes: [myw.WidgetRendererMixin],

    /**
     * @class UI Representation of a layer
     * @param  {LayerControl}  options.control
     * @param  {layerListItem}     options.model
     * @param  {Layer}         options.layer
     * @param  {string}            options.description  Text to show in the tooltip when you hover over the layer row
     * @constructs
     * @extends  {Backbone.View}
     * @mixes  {WidgetRendererMixin}
     */
    initialize(options) {
        myw.View.prototype.initialize.call(this, options);

        const layer = options.layer;
        this.layer = layer;
        this.model = options.model;
        this.control = options.control;

        this.layerView = new myw.LayerControlItem(options.control, {
            layerRow: this,
            layerItem: this.model,
            layer: layer,
            description: options.description,
            widgetDefinitions: this.getDefinitions(layer.layerDef.control_item_class)
        });
        this.render();
    },

    render() {
        const layerItem = this.model;

        this.setElement(
            this.innerTemplate({
                baseUrl: myw.baseUrl,
                layer: layerItem
            })
        );

        this.checkbox = new myw.LayerCheckbox({ layer: layerItem, type: 'layer-checkbox' });

        this.$el.append(this.checkbox.$el);

        this.layerView.render();
        this.$el.prepend(this.layerView.el);
    },

    /**
     * Updates the enabled, valid and checked state of the layer
     */
    update() {
        this.enableOrDisable(this.layer.isEnabled);
        this.updateInvalidClass(this.layer.isInvalid);
        this.checkCheckbox(this.layer.isChecked);
    },

    /**
     * Removes the layer from the list and from the map
     */
    remove(ev) {
        this.$el.remove();
        this.control.removeLayer(this);
    },

    /**
     * Enables or Disables (based on the enableLayer parameter) the overlay in the layers panel
     * by changing its style.
     * @param  {boolean} enableLayer
     */
    enableOrDisable(enableLayer) {
        if (enableLayer) this.$el.removeClass('overlay-disabled');
        else this.$el.addClass('overlay-disabled');
    },

    /**
     * Adds an invalid class to the sub layer if its inValid, else removes it
     * @param  {Boolean} isInvalid If the layer should be marked as inValid or not
     */
    updateInvalidClass(isInvalid) {
        this.$el.toggleClass('overlay-invalid', isInvalid);
    },
    /**
     * Sends the click to the layer's checkbox
     */
    toggleCheckbox(ev) {
        if (!this.control.isEditMode) {
            this.checkbox.change();
        }
    },

    /**
     * Handles the checkbox click on the layer control
     * @private
     */
    updateSelection(ev) {
        ev.stopPropagation(); //TODO: Do we really need this?
        if (!this.control.isEditMode) {
            this.setLayerChecked();
        }
    },

    /**
     * Asks the layerManager to make the layer visible is its checkbox is checked and vice versa
     */
    setLayerChecked() {
        const layerName = this.model.layer_name,
            checked = this.checkbox.isChecked();
        this.control.layerManager.setLayerChecked(layerName, checked);
        this.model.turned_on = checked; // Updates the model
    },
    /**
     * Updates the layer's checkbox
     * @param  {boolean} checked State that needs to be assigned to the layer checkbox
     */
    checkCheckbox(checked) {
        this.checkbox.setChecked(checked);
        this.model.turned_on = checked; // Updates the model
    },

    /**
     * Enable the layers that don't have the checkbox-disabled and/or out-of-scale data attribute set to true
     * This is to keep the inactive layers disabled
     */
    enable() {
        if (this.control.layerManager.layers[this.model.layer_name].isEnabled) {
            this.checkbox.enable();
        }
    },

    disable() {
        this.checkbox.disable();
    }
});

export default myw.LayerControlRow;
